import { once } from "@/fp";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import { UseLoading } from "@/common/composition/loading";
import { computed } from "@vue/composition-api";
const [is_loading_all, set_is_loading_all] = UseLoading(false).as_arr();
import { state as csv_state } from "./csv/state.csv";
import { pdf_state } from "./pdf/state.pdf";
import { UseTabs } from "@/common/composition/use-tabs";
import { SharedState } from "@/common/state";

const the_tabs = [
  { id: "csv", name: "Exported Lists", icon: "csv" },

  {
    id: "pdf",
    name: "Reports",
    icon: "pdf",
    soon: false,
    disable: false,
  },
  {
    id: "executive",
    name: "Executive Reports",
    icon: "pdf",
    soon: false,
    disable: false,
  },
  {
    id: "scheduled",
    name: "Scheduled Manager",
    icon: "Calendar",
    soon: false,
    disable: false,
  },
  {
    id: "events_justification",
    name: "Events Justifications",
    icon: "Email",
  },
];
const [tabs, current_tab, _set_current_tab, , update_tab] = UseTabs(
  the_tabs,
  the_tabs[0]
);

const index_of = (id: string) => tabs.value.findIndex((d) => d.id == id);

const init = once(() => {
  SharedState.onReady(async () => {
    set_is_loading_all(true);
    await data_sources_state.init();

    const is_scheduled_enabled = SharedState.FeatureHelper.is_enabled(
      "risky_events_report"
    );

    const is_executive_reports_enabled =
      SharedState.FeatureHelper.is_enabled("executive_reports");

    const is_pdf_enabled =
      SharedState.FeatureHelper.is_enabled("pdf_report") ||
      SharedState.FeatureHelper.is_enabled("pdf_report_schedule");

    update_tab(index_of("pdf"), {
      id: "pdf",
      name: "Reports",
      icon: "pdf",
      soon: !is_pdf_enabled,
      disable: !is_pdf_enabled,
    });

    const executive_tab_index = index_of("executive");
    if (executive_tab_index !== -1) {
      update_tab(executive_tab_index, {
        id: "executive",
        name: "Executive Reports",
        icon: "pdf",
        soon: false,
        disable: !is_executive_reports_enabled,
      });
    }
    update_tab(index_of("scheduled"), {
      id: "scheduled",
      name: "Schedule Manager",
      icon: "Calendar",
      soon: !is_scheduled_enabled,
      disable: !is_scheduled_enabled,
    });
    if (SharedState.restrictions.is_restricted_app("reports")) {
      _set_current_tab(the_tabs[3]);
    }

    await Promise.all([pdf_state.init(), csv_state.init()]);
    set_is_loading_all(false);
  });
});

const set_current_tab = (tab: { id: string; name: string; icon: string }) => {
  if (SharedState.is_biz_user.value) {
    switch (tab.id) {
      case "csv":
      case "pdf":
      case "executive":
      case "scheduled":
        if (SharedState.restrictions.is_restricted_app("reports")) {
          SharedState.restrictions.show_restrictions_modal("app", "Reports");
        } else {
          _set_current_tab(tab);
        }
        break;
      case "events_justification":
      default:
        if (SharedState.restrictions.is_restricted_app("event_justification")) {
          SharedState.restrictions.show_restrictions_modal(
            "app",
            "Event Justification"
          );
        } else {
          _set_current_tab(tab);
        }
        break;
    }
  } else {
    _set_current_tab(tab);
  }
};

const is_show_reports_loader = computed(
  () =>
    is_loading_all.value ||
    pdf_state.is_loading.value ||
    csv_state.is_loading.value
);

export const state = {
  init,
  tabs,
  current_tab,
  set_current_tab,
  is_show_reports_loader,
};
